/* Shams Everyday — storefront enhancements */

/* 1) Product page "Buy Now" (اشترِ الآن): add selected variant then go to /checkout */
(function () {
  var LABEL = 'Buy now';
  function addBuyNow() {
    var container = document.querySelector('.product-form__buttons');
    if (!container) return;
    var form = container.querySelector('form') || document.querySelector('product-form form');
    var submit = container.querySelector('.product-form__submit');
    var existing = container.querySelector('.shams-buy-now-pdp');
    if (!form || !submit || submit.disabled || submit.getAttribute('aria-disabled') === 'true') {
      if (existing) existing.remove();
      return;
    }
    if (existing) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'shams-buy-now-pdp';
    btn.textContent = LABEL;
    submit.insertAdjacentElement('afterend', btn);
    btn.addEventListener('click', function () {
      var idEl = form.querySelector('[name="id"]');
      if (!idEl || !idEl.value) { if (submit) submit.click(); return; }
      var qtyEl = form.querySelector('[name="quantity"]');
      var qty = qtyEl && qtyEl.value ? qtyEl.value : 1;
      btn.setAttribute('aria-busy', 'true');
      btn.style.opacity = '0.7';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: idEl.value, quantity: qty }] })
      }).then(function () { window.location.href = '/checkout'; })
        .catch(function () { window.location.href = '/checkout'; });
    });
  }
  if (document.readyState !== 'loading') { addBuyNow(); }
  document.addEventListener('DOMContentLoaded', addBuyNow);
  document.addEventListener('change', function () { setTimeout(addBuyNow, 50); });
  document.addEventListener('shopify:section:load', addBuyNow);
})();

/* 2) Cart drawer: free-shipping progress bar + upsell strip (reach 1000 EGP) */
(function () {
  var THRESHOLD = 100000;
  var AR = (document.documentElement.lang || '').toLowerCase().indexOf('ar') === 0;
  var recCache = null, recFetching = false, recFetched = false;
  function egp(c) { return Math.ceil(c / 100).toLocaleString('en-US'); }
  function barHTML(total) {
    var rem = Math.max(0, THRESHOLD - total);
    var pct = total <= 0 ? 0 : Math.max(4, Math.min(100, (total / THRESHOLD) * 100));
    var msg = rem > 0
      ? (AR
        ? ('أضف <strong>' + egp(rem) + ' جنيهًا مصريًا</strong> أخرى واحصل على الشحن المجاني')
        : ('Add <strong>EGP ' + egp(rem) + '</strong> more for free shipping'))
      : (AR ? 'تم تفعيل الشحن المجاني' : 'Free shipping unlocked');
    return '<div class="shams-ship__msg">' + msg + '</div>' +
      '<div class="shams-ship__track"><div class="shams-ship__fill" style="width:' + pct + '%;"></div></div>';
  }
  function cardHTML(p) {
    var img = p.featured_image || (p.images && p.images[0]) || '';
    if (img) { img = img + (img.indexOf('?') === -1 ? '?' : '&') + 'width=200'; }
    var price = (p.price_max != null ? p.price_max : p.price);
    var vid = null, avail = false, i;
    if (p.variants) {
      for (i = 0; i < p.variants.length; i++) { if (p.variants[i].available) { vid = p.variants[i].id; avail = true; break; } }
      if (!vid && p.variants[0]) { vid = p.variants[0].id; }
    }
    var imgTag = img ? ('<img src="' + img + '" alt="" loading="lazy">') : '';
    return '<div class="shams-up__card">' +
      '<a class="shams-up__img" href="' + p.url + '">' + imgTag + '</a>' +
      '<a class="shams-up__title" href="' + p.url + '">' + p.title + '</a>' +
      '<div class="shams-up__row"><span class="shams-up__price">' + 'EGP ' + egp(price) + '</span>' +
      '<button type="button" class="shams-up__add" data-vid="' + vid + '" aria-label="Add to cart"' + (avail ? '' : ' disabled') + '>+</button></div>' +
      '</div>';
  }
  function fetchRecs(cart) {
    var pid = cart.items && cart.items.length ? cart.items[0].product_id : null;
    if (!pid) return;
    recFetching = true;
    fetch('/recommendations/products.json?product_id=' + pid + '&limit=10&intent=related', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) { recCache = d.products || []; recFetched = true; recFetching = false; refresh(); })
      .catch(function () { recFetching = false; });
  }
  function renderUpsell(host, cart) {
    var existing = host.querySelector(':scope > .shams-up');
    var show = cart.total_price > 0 && cart.total_price < THRESHOLD;
    if (!show) { if (existing) existing.remove(); return; }
    if (!recFetched && !recFetching) { fetchRecs(cart); }
    var inCart = {}; cart.items.forEach(function (it) { inCart[it.product_id] = 1; });
    var prods = (recCache || []).filter(function (p) { return !inCart[p.id]; })
      .sort(function (a, b) { return (a.price_max != null ? a.price_max : a.price) - (b.price_max != null ? b.price_max : b.price); }).slice(0, 8);
    if (!prods.length) { if (existing) existing.remove(); return; }
    var up = existing;
    var cartItems = host.querySelector(':scope > cart-drawer-items');
    if (!up) {
      up = document.createElement('section');
      up.className = 'shams-up';
    }
    up.setAttribute('aria-labelledby', 'ShamsUpsellHeading');
    up.style.marginTop = '.8rem';
    up.style.borderTop = '1px solid var(--shams-line)';
    up.style.background = 'rgba(250, 248, 244, .78)';
    if (cartItems) {
      cartItems.insertAdjacentElement('afterend', up);
    } else {
      var footer = host.querySelector(':scope > .drawer__footer');
      if (footer) { host.insertBefore(up, footer); } else { host.appendChild(up); }
    }
    up.innerHTML = '<div style="font-size:1.05rem;letter-spacing:.04em;color:#6a5a46;margin-bottom:.2rem;">' + (AR ? 'منتجات مقترحة' : 'Recommended products') + '</div>' +
      '<h3 id="ShamsUpsellHeading" class="shams-up__head" style="margin-top:0;">' + (AR ? 'أضف إلى طلبك ووفّر في الشحن' : 'Add to your order and save on shipping') + '</h3>' +
      '<div class="shams-up__scroll">' + prods.map(cardHTML).join('') + '</div>';
  }
  function place(cart) {
    var host = document.querySelector('#CartDrawer .drawer__inner');
    if (!host) return;
    var drawer = document.querySelector('cart-drawer');
    if (drawer && drawer.classList.contains('is-empty')) return;
    var anchor = host.querySelector(':scope > cart-drawer-items');
    var bar = host.querySelector(':scope > .shams-ship');
    if (!bar) { bar = document.createElement('div'); bar.className = 'shams-ship'; if (anchor) { host.insertBefore(bar, anchor); } else { host.appendChild(bar); } }
    bar.innerHTML = barHTML(cart.total_price);
    if (cart.total_price >= THRESHOLD) { bar.classList.add('shams-ship--done'); } else { bar.classList.remove('shams-ship--done'); }
    var cartLabel = host.querySelector(':scope > .shams-cart-label');
    if (!cartLabel) {
      cartLabel = document.createElement('h3');
      cartLabel.className = 'shams-cart-label';
      cartLabel.id = 'ShamsCartItemsHeading';
      cartLabel.style.cssText = 'margin:0;padding:.8rem 1.2rem .35rem;border-top:1px solid var(--shams-line);font-size:1.3rem;font-weight:700;color:var(--shams-ink);';
    }
    cartLabel.textContent = AR ? 'منتجاتك في السلة' : 'Your cart items';
    if (anchor) {
      host.insertBefore(cartLabel, anchor);
      anchor.setAttribute('role', 'region');
      anchor.setAttribute('aria-labelledby', 'ShamsCartItemsHeading');
    }
    renderUpsell(host, cart);
  }
  var busy = false;
  function refresh() {
    if (busy) return; busy = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { place(c); })
      .catch(function () {})
      .then(function () { busy = false; });
  }
  function reopenDrawer() {
    var dr = document.querySelector('cart-drawer');
    if (dr) { dr.classList.remove('is-empty'); if (!dr.classList.contains('active')) { dr.classList.add('animate', 'active'); } }
  }
  document.addEventListener('click', function (e) {
    var add = e.target.closest && e.target.closest('.shams-up__add');
    if (add) {
      e.preventDefault(); e.stopPropagation();
      var vid = add.getAttribute('data-vid');
      if (!vid || vid === 'null') return;
      add.textContent = '✓'; add.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: vid, quantity: 1 }], sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: location.pathname })
      }).then(function (r) { return r.json(); })
        .then(function (s) {
          if (s && s.sections && s.sections['cart-drawer']) {
            var tmp = document.createElement('div'); tmp.innerHTML = s.sections['cart-drawer'];
            var nd = tmp.querySelector('#CartDrawer'), cur = document.querySelector('#CartDrawer');
            if (nd && cur) { cur.innerHTML = nd.innerHTML; }
            if (s.sections['cart-icon-bubble']) {
              var bw = document.getElementById('cart-icon-bubble');
              if (bw) { var t2 = document.createElement('div'); t2.innerHTML = s.sections['cart-icon-bubble']; var nb = t2.querySelector('#cart-icon-bubble'); bw.innerHTML = nb ? nb.innerHTML : t2.innerHTML; }
            }
          }
          reopenDrawer();
          refresh();
        }).catch(function () { refresh(); });
      return;
    }
    if (e.target.closest && e.target.closest('#cart-icon-bubble, a[href$="/cart"], .header__icon--cart')) { setTimeout(refresh, 350); }
  });
  if (document.readyState !== 'loading') { refresh(); }
  document.addEventListener('DOMContentLoaded', refresh);
  var cd = document.getElementById('CartDrawer');
  if (cd) {
    var t;
    new MutationObserver(function () {
      if (!document.querySelector('#CartDrawer .shams-ship')) { clearTimeout(t); t = setTimeout(refresh, 80); }
    }).observe(cd, { childList: true, subtree: true });
  }
})();

/* 3) Footer: Kashier payment icons + remove "Powered by Shopify" */
(function () {
  var PAY = '<div class="shams-pay" aria-label="Payment methods">' +
    '<span class="shams-pay__chip"><span class="shams-pay__visa">VISA</span></span>' +
    '<span class="shams-pay__chip"><svg class="shams-pay__mc" viewBox="0 0 32 20" xmlns="http://www.w3.org/2000/svg"><circle cx="13" cy="10" r="6.3" fill="#eb001b"/><circle cx="19" cy="10" r="6.3" fill="#f79e1b"/><path d="M16 5.4a6.3 6.3 0 0 0 0 9.2 6.3 6.3 0 0 0 0-9.2z" fill="#ff5f00"/></svg></span>' +
    '<span class="shams-pay__chip"><span class="shams-pay__meeza">ميزة</span></span>' +
    '<span class="shams-pay__chip shams-pay__chip--fawry"><span class="shams-pay__fawry">fawry</span></span>' +
    '<span class="shams-pay__chip"><span class="shams-pay__valu">valU</span></span>' +
    '</div>';
  function enhanceFooter() {
    document.querySelectorAll('.footer__copyright .copyright__content').forEach(function (el) {
      if (el.querySelector('a[href*="shopify.com"]') || /powered by shopify/i.test(el.textContent)) { el.remove(); }
    });
    if (!document.querySelector('.footer .shams-pay')) {
      var pay = document.querySelector('.footer__payment');
      if (pay) { var ul = pay.querySelector('.list-payment'); if (ul) { ul.remove(); } pay.insertAdjacentHTML('beforeend', PAY); }
      else {
        var info = document.querySelector('.footer__content-bottom .footer__column--info') || document.querySelector('.footer__content-bottom-wrapper');
        if (info) { info.insertAdjacentHTML('beforeend', PAY); }
      }
    }
  }
  if (document.readyState !== 'loading') { enhanceFooter(); }
  document.addEventListener('DOMContentLoaded', enhanceFooter);
})();
